<template>
  <div>
    <el-dialog
      class="invoice-apply-dialog"
      @opened="opened"
      :visible.sync="visible"
      :fullscreen="true"
      :before-close="closeDialog">
      <template slot="title">
        {{file_title}}
      </template>
      <div v-html="contentHtml"></div>
    </el-dialog>
  </div>
</template>

<script>
import { getToken } from '@utils/auth'
import emlformat from '@/vendor/eml-format'
export default {
  data () {
    return {
      contentHtml: ''
    }
  },
  props: {
    visible: Boolean,
    file_title: String,
    url: String,
  },
  computed: {},
  watch: {
    url: {
      handler (val) {
        if (val) {
          this.getAttachFileContent(val)
        }
      },
    }
  },
  created () {

  },
  methods: {
    getAttachFileContent (url) {
      axios.get(url, {headers: {
        'SJ-Auth-Token': getToken()
      }}).then(({data}) => {
        let contentHtml = data.toString()
        if (contentHtml.indexOf('Transfer-Encoding: quoted-printable') !== -1) { // eml 邮件
          emlformat.read(contentHtml, (_, data) => {
            this.contentHtml = data.html
          })
        } else { // html
          this.contentHtml = contentHtml
        }
      })
    },
    opened () {},
    closeDialog () {
      this.$emit('closeDialog')
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/views/payment-manager-new/components/AttachedFile.vue